import {
  conditionKey,
  fixNewConditions,
  getConditionsObjects,
  medicationsFromDTO,
  medicationsToDTO,
} from '../../../../utils/rpmPatientFields';

// Editing the patient medications list (Medical History) straight from the Medications table, with the edit-medication
// dialog alone instead of the onboard-patient wizard. Built on the wizard's own helpers (rpmPatientFields): the dialog's
// input, and the patient update its result turns into.

// The patient as the edit-medication dialog expects it, like the wizard's getPatientFromProps and condition hydration.
export const getEditablePatient = (patientDetails, orgConditions) => ({
  ...patientDetails,
  conditionsObjects: getConditionsObjects(Object.keys(patientDetails?.conditions || {}), patientDetails?.conditions, orgConditions),
  medications: medicationsFromDTO(patientDetails?.medications),
});

// The conditions the dialog selected that the patient doesn't have yet. Those with only an ICD code (no id) must be
// created as org conditions before they can be referenced.
export const getMissingConditions = (patient, medicationConditions) => (medicationConditions || [])
  .filter(c => !(patient.conditionsObjects || []).some(co => conditionKey(co) === conditionKey(c)));

// The patient update for the edited entry (or the added one, when medIndex is undefined): the whole medications list
// (the backend replaces it), plus the patient's conditions when some were added. Condition keys become ids the way the
// wizard's save does it (fixNewConditions); createdConditions are the missing ones created for this save, with their ids.
export const getMedicationUpdate = (patient, updatedMedication, medIndex, missingConditions, createdConditions) => {
  const medications = medIndex === undefined
    ? [...patient.medications, updatedMedication]
    : patient.medications.map((m, index) => (index === medIndex ? updatedMedication : m));
  const fixed = fixNewConditions(
    { ...patient, medications, conditionsObjects: [...(patient.conditionsObjects || []), ...missingConditions] },
    createdConditions,
  );
  return {
    medications: medicationsToDTO(fixed.medications),
    ...(missingConditions.length > 0 ? { conditions: fixed.conditions } : {}),
  };
};

// The patient update removing the entry at medIndex from the patient's medications list (sent whole, as the backend
// replaces it). The entries are the patient details' own, already in the backend's format.
export const getMedicationRemoval = (patientDetails, medIndex) => ({
  medications: (patientDetails?.medications || []).filter((_, index) => index !== medIndex),
});
